module.exports = __webpack_public_path__ + "img/right.df6a4273.png";